export const WasteBreakdownOptions = [
  { label: 'Material', value: 'material' },
  { label: 'Treatment Method', value: 'treatment' },
] as const;

export type WasteBreakdownValue = (typeof WasteBreakdownOptions)[number]['value'];

export type { WastePeriodValue } from 'models/WasteDashboard/wasteGenerated.model';

export type WastePeriodFilter =
  | { type: 'annual' }
  | { type: 'month'; month: number }
  | { type: 'quarter'; quarter: number };

export const toPeriodQueryParams = (
  filter: WastePeriodFilter
): { month?: number; quarter?: number } => {
  if (filter.type === 'month') return { month: filter.month };
  if (filter.type === 'quarter') return { quarter: filter.quarter };
  return {};
};

export const fromAppliedFilters = (
  month?: string,
  quarter?: string
): WastePeriodFilter => {
  if (month) return { type: 'month', month: Number(month) };
  if (quarter) return { type: 'quarter', quarter: Number(quarter) };
  return { type: 'annual' };
};

export const MONTH_OPTIONS = [
  { label: 'Jan', value: '1' },
  { label: 'Feb', value: '2' },
  { label: 'Mar', value: '3' },
  { label: 'Apr', value: '4' },
  { label: 'May', value: '5' },
  { label: 'Jun', value: '6' },
  { label: 'Jul', value: '7' },
  { label: 'Aug', value: '8' },
  { label: 'Sep', value: '9' },
  { label: 'Oct', value: '10' },
  { label: 'Nov', value: '11' },
  { label: 'Dec', value: '12' },
];

export const QUARTER_OPTIONS = [
  { label: 'Q1', value: '1' },
  { label: 'Q2', value: '2' },
  { label: 'Q3', value: '3' },
  { label: 'Q4', value: '4' },
];

export const WasteDashboardText = {
  DASHBOARD: 'Waste Dashboard',
  YOY_TEXT: 'Waste Diversion Rate by Year',
  MATERIAL_TEXT: 'Waste by Material',
  BREAKDOWN_TEXT: 'Waste Breakdown by Material and Treatment Method',
  KPI_TOTAL_WASTE: 'Total Waste',
  KPI_LANDFILL_WASTE: 'Landfill Waste',
  KPI_DIVERTED_WASTE: 'Diverted Waste',
  KPI_DIVERSION_RATE: 'Diversion Rate',
  DATA_EMPTY: 'Complete Scope 3: Category 5 data entry to view waste details',
  ALL: 'All',
  YEAR: 'Year',
  UNIT_TONNES: 'tonnes',
  UNIT_PERCENT: '%',
  SELECT_TEXT: 'Select',
  SELECT_MONTH: 'Select Month',
  SELECT_QUARTER: 'Select Quarter',
  WARNING_TITLE_YOY_DIVERSION: 'Waste Diversion Rate Info',
  WARNING_TITLE_MATERIAL: 'Waste by Material Info',
  WARNING_TITLE_TREATMENT: 'Waste by Treatment Method Info',
  WARNING_TITLE_BREAKDOWN: 'Waste Breakdown Info',
  TOOLTIP_MATERIAL: 'Material :',
  TOOLTIP_TREATMENT: 'Treatment Method :',
  TOOLTIP_WASTE: 'Waste :',
};
